import axios from "axios";
import { getEnvVariable, REACT_APP_API_URL } from "utils/environment";
import { retrieveTokenFromLocalStorage } from "services/utils/serviceutils";

export const getConfigurationParams = () => {
  const url = `${getEnvVariable(REACT_APP_API_URL)}configurationParams/`;
  const config: any = {
    method: "get",
    url: url,
    headers: {
      Authorization: `Bearer ${retrieveTokenFromLocalStorage()}`,
    },
  };
  return axios(config);
};
